import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ProviderFieldService } from '../services';
import { PROVIDER_FIELD_LIST_KEY } from '../constants/provider-field.queries';
import { PROVIDER_FIELDS_BY_TYPE_KEY } from './useProviderFieldsByType';

export const useDeleteProviderField = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('providerField');
  return useMutation(() => ProviderFieldService.delete(id), {
    onSuccess: () => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries({ queryKey: [PROVIDER_FIELD_LIST_KEY] });
      queryClient.invalidateQueries({ queryKey: [PROVIDER_FIELDS_BY_TYPE_KEY] });
      queryClient.invalidateQueries({ queryKey: [id] });
    },
  });
};
